import React, { useState } from 'react';
import ActionsItem from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions/ActionsItem';
import Actions from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions';

import ChatModal from '../Layout/Chat/ChatModal';
import Headline from '../ui/Typography/Headline';
import Textarea from '../ui/Controls/Textarea';
import Button from '../ui/Controls/Button';
import Rating from '../Feedback/Rating';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setActiveModal } from '../../store/slices/modals';
import { sendFeedback } from '../../store/actions/chat';
import { modalDataSelector } from '../../store/selectors/modals';
import { $l } from '../../locales';
import setQaAttribute from '../../helpers/setQaAttribute';
import {
  CHAT_MODAL_FEEDBACK_CANCEL,
  CHAT_MODAL_FEEDBACK_SEND,
  CHAT_MODAL_FEEDBACK_TEXTAREA,
} from '../../constants/qaAttributes';

const FeedbackChat = () => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(modalDataSelector);
  const [loading, setLoading] = useState(false);
  const [feedbackText, setText] = useState('');
  const [score, setScore] = useState(0);
  const [clicked, setClicked] = useState(false);
  const selectedScore = score || +data.score;

  const closeModal = () => {
    dispatch(setActiveModal(''));
  };

  const selectScore = (score: number) => {
    setScore(score);
  };

  const changeText = ({ target: { value = '' } }) => {
    setText(value);
  };

  const send = async () => {
    try {
      setClicked(true);
      setLoading(true);

      dispatch(
        sendFeedback(+data.chatId, {
          comment: feedbackText.trim() || undefined,
          score: selectedScore,
          hash: data.hash.toString(),
        }),
      );
      closeModal();
    } finally {
      setLoading(false);
    }
  };

  return (
    <ChatModal>
      <Headline fontSize="20" lineHeight="24" fontWeight="500" className="indent-sm-bottom">
        {$l('PLEASE_RATE')}
      </Headline>
      <Rating rateSelect={selectScore} value={selectedScore} />
      <Textarea
        placeholder={$l('ADD_ADDITIONAL_FEEDBACK')}
        className="indent-lg-bottom indent-lg-top"
        onChange={changeText}
        value={feedbackText}
        {...setQaAttribute(CHAT_MODAL_FEEDBACK_TEXTAREA)}
      />
      <Actions width="full" gap="8" direction="column">
        <ActionsItem width="full">
          <Button
            text={$l('SUBMIT')}
            disabled={loading || (clicked && !selectedScore)}
            onClick={send}
            {...setQaAttribute(CHAT_MODAL_FEEDBACK_SEND)}
          />
        </ActionsItem>
        <ActionsItem width="full">
          <Button
            variant="primary-text"
            text={$l('CLOSE')}
            onClick={closeModal}
            {...setQaAttribute(CHAT_MODAL_FEEDBACK_CANCEL)}
          />
        </ActionsItem>
      </Actions>
    </ChatModal>
  );
};

export default FeedbackChat;
